// Shared "just-skipped-typing" lock.
//
// When the user presses Enter to skip the typing animation, the typing finishes
// almost instantly. If a second Enter follows quickly, it would otherwise reach
// the input form and submit a blank command — eating the next block's prompt.
//
// markSkip() is called from useTypingSkip when a skip is triggered.
// wasJustSkipped() is checked from TerminalInput's Enter handler before submit.
const LOCK_MS = 500;

let lastSkipAt = 0;

export const markSkip = () => {
  lastSkipAt = Date.now();
};

export const wasJustSkipped = () => Date.now() - lastSkipAt < LOCK_MS;
